export const PARTNER_DOCUMENTS_MAPPER = [
    {
        title: 'Income Proof',
        tileStatus: 'Not yet uploaded',
        pages: [
            {
                docName: 'bankStatement',
                docType: 'BANK_STATEMENT',
                pageTitle: 'Bank Statement',
                status: false,
                display: true,
                navigateURl: '/bil/upload-document/bank-statement',
                hint: 'Last 6 months'
            },
            {
                docName: 'itr',
                docType: 'ITR',
                pageTitle: 'ITR',
                status: false,
                display: false,
                navigateURl: '/bil/upload-document/itr',
                hint: 'Last 2 Years'
            }
        ]
    },
    {
        title: 'Entity KYC',
        tileStatus: 'Not yet uploaded',
        pages: [
            {
                pageTitle: 'Registration Proof',
                docType: 'REGISTRATION_PROOF',
                status: false,
                display: true,
                navigateURl: '/bil/upload-document/registration-proof'
            },
            {
                pageTitle: 'Company PAN',
                docType: 'PAN',
                status: false,
                display: true,
                navigateURl: '/bil/upload-document/company-pan'
            },
            {
                pageTitle: 'Operational Address',
                docType: 'OPERATIONAL_ADDRESS',
                status: false,
                display: true,
                navigateURl: '/bil/upload-document/operational-address'
            }
        ]
    },
    {
        title: "Partner’s KYC",
        tileStatus: 'Not yet uploaded',
        pages: [
            {
                pageTitle: 'PAN and Address Proof',
                status: false,
                display: true,
                navigateURl: '/bil/upload-document/owner-kyc'
            }
        ]
    }
]